import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { EntityLevelSummariesDTO } from '../../../../api/useBalanceSheetQuery';
import { AssetsCard } from '../../components/AssetsCard/AssetsCard';
import { Owner } from '../../components/Owner/Owner';
import { Table } from '../../components/Table/Table';

interface Props {
  data: EntityLevelSummariesDTO[];
}

export const TrustsAndEntities = ({ data }: Props) => {
  return (
    <>
      {data.map((entitySummary, index) => (
        <Box key={index} mb="24">
          {/* PDF FIX */}
          {index === 0 && (
            <Text fontSize="h3" fontWeight={600} mb="24">
              Entity Balance Sheet
            </Text>
          )}

          <Box mb="24">
            <AssetsCard title={entitySummary.chartLabel} {...entitySummary} />
          </Box>

          <Box mb="24">
            <Table tableData={entitySummary.table} />
          </Box>

          {entitySummary.owners.length > 0 && (
            <Box
              display="flex"
              justifyContent="center"
              flexWrap="wrap"
              css={({ theme }) => ({
                gap: theme.space['32'],
                'page-break-inside': 'avoid',
                breakInside: 'avoid',
              })}
            >
              {entitySummary.owners.map((owner, childIndex) => {
                const { name, percentage, type, value, valueLabel, color } = owner;

                return (
                  <Owner
                    key={childIndex}
                    name={name}
                    valueLabel={valueLabel}
                    value={value}
                    type={type}
                    percentage={percentage}
                    color={color}
                  />
                );
              })}
            </Box>
          )}
        </Box>
      ))}
    </>
  );
};
